import React from 'react';
import { useTranslation } from 'react-i18next';
import { SecondarySection, SectionSubTitle, Typography } from 'common/components';
import { CeilingsMoreInfo } from '../ceilings-more-info';
import { MountingTypeGallery } from './mounting-type-gallery';
import { MOUNTING_TYPE_LIST } from './ceilings-mounting-type-section-constants';
import {
  ceilingsMountingTypeLayout,
  ceilingsMountingTypeText,
  ceilingsMountingTypeMoreInfo,
  hiddenCorniceTextContainer,
} from './ceilings-mounting-type-section-styles';

type CeilingsMountingTypeSectionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const CeilingsMountingTypeSection = ({
  onConsultationSignupBtnClick,
}: CeilingsMountingTypeSectionProps) => {
  const { t } = useTranslation();

  return (
    <SecondarySection className={ceilingsMountingTypeLayout}>
      <SectionSubTitle adaptiveMargin margin="s">
        {t('mounting-type-section.title')}
      </SectionSubTitle>
      <Typography adaptive={false} className={ceilingsMountingTypeText} variant="l" size="body_long">
        {t('mounting-type-section.subtitle')}
      </Typography>

      <CeilingsMoreInfo
        cardList={MOUNTING_TYPE_LIST}
        cardPerRow={3}
        className={ceilingsMountingTypeMoreInfo}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />

      <div className={hiddenCorniceTextContainer}>
        <Typography adaptive={false} variant="h3">
          {t('mounting-type-section.hidden.title')}
        </Typography>
        <Typography adaptive={false} variant="m" size="body_long">
          {t('mounting-type-section.hidden.description')}
        </Typography>
      </div>

      <MountingTypeGallery onConsultationSignupBtnClick={onConsultationSignupBtnClick} />
    </SecondarySection>
  );
}
